import type { TripChatExportFormat } from 'tripPlanner/api/v3'
import type { TripPlannerSurfaceActivityEntry } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityEntryTypes'
import { boundActivityDisplayText } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityDisplayText'

function formatLabel(format: TripChatExportFormat): string {
  return format === 'pdf' ? 'PDF' : 'spreadsheet'
}

export function buildItineraryDownloadedActivityEntry(format: TripChatExportFormat): TripPlannerSurfaceActivityEntry {
  return {
    kind: 'itinerary_downloaded',
    label: 'Downloaded itinerary',
    displayText: boundActivityDisplayText(`Downloaded itinerary as ${formatLabel(format)}`),
    sourcePath: 'trip_planner.itinerary.download',
    dataClassification: 'personalised_surface',
    occurredAt: new Date().toISOString(),
  }
}
